import { createContext, useContext, useEffect } from 'react'

// Lets a nested modal stop its parent from closing on Escape while it's open.
// No-op by default, so nested modals also work without a parent.
export const NestedModalContext = createContext<(open: boolean) => void>(
  () => {}
)

export const useRegisterNestedModal = (opened: boolean) => {
  const setNestedModalOpen = useContext(NestedModalContext)

  useEffect(() => {
    setNestedModalOpen(opened)
  }, [opened, setNestedModalOpen])
}
